import React, { useContext, useEffect, useRef, useState } from "react";
import { DataContext } from "../../../Context/DataContext";
import { NotificationContext } from "../../../Context/NotificationContext";

import { ReactComponent as MORE } from "../../../assets/icons/More.svg";
import { ReactComponent as MORESELECTED } from "../../../assets/icons/More-selected.svg";
import { ReactComponent as DELCARD } from "../../../assets/icons/Delete-card.svg";

import { useSpring, animated } from "react-spring";

import PopUpModal from "../../../NewComponents/PopUpModal";
import NewButton from "../../../NewComponents/NewButton";
import { FormTextInput } from "../../../Components/FormTextInput";
import { FormCardInput } from "../../../NewComponents/ForumCardInput";
import { Check } from "react-feather";
import { AuthContext } from "../../../Context/AuthContext";
import axios from "axios";

import VISA from "../../../assets/icons/visa.png";
import MASTER from "../../../assets/icons/mastercard.png";
import AMEX from "../../../assets/icons/amex.png";
import DINER from "../../../assets/icons/diner.png";
import DISCOVER from "../../../assets/icons/discover.png";
import MAESTRO from "../../../assets/icons/maestro.png";
import JCB from "../../../assets/icons/jcb.png";
import CARDICON from "../../../assets/icons/Card.png";

import {
  CardNumberElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import NoData from "../../../NewComponents/NoData";
import "./Billing.css";
import { firestore, getFullHttpUrl } from "../../../firebase.config";
import { AccountType } from "../../../utility/enums";
import { getTeamOwnerEmail } from "../../../Data/Functions";

const Billing = ({
  type = "payment",
  setSelectedCard,
  selectedCard,
  cardOwner,
  setCardOwner,
  saveCard,
  setSaveCard,
  setDefaultCard = (e) => { },
  cardsList,
  setCardsList,
  windowSize,
  pendingInvoices,
  showChargeWarning= false,
  showNewCard=true,
  onStripeReady = () => {}
}) => {
  const { userData, teamData } = useContext(DataContext);
  const { signedIn } = useContext(AuthContext);
  const { showNotification } = useContext(NotificationContext);

  const [editCardIconSelected, setEditCardIconSelected] = useState("");
  const [editCard, setEditCard] = useState("");
  const [deleteModalCard, setDeleteModalCard] = useState(null);

  const [isCardsLoading, setIsCardsLoading] = useState(false);

  const [saveEditsBtnText, setSaveEditsBtnText] = useState("Save");
  const [deleteBtnText, setDeleteBtnText] = useState("Delete Card");

  const [cardNumberLoaded, setCardNumberLoaded] = useState(false);
  const [cardCvcLoaded, setCardCvcLoaded] = useState(false);
  const [cardExpiryLoaded, setCardExpiryLoaded] = useState(false);

  const [cardNumberEmpty, setCardNumberEmpty] = useState("");
  const [cardCVCEmpty, setCardCVCEmpty] = useState("");
  const [cardExpiryEmpty, setCardExpiryEmpty] = useState("");

  const [customerId, setCustomerId] = useState("");

  const stripe = useStripe();
  const elements = useElements();

   useEffect(() => {
      if(stripe &&  elements){
        onStripeReady({stripe, elements});
      }
    }, [stripe, elements, onStripeReady])


  const getCustomerId = async (id, isTeam) => {
    const email = isTeam && userData ? await getTeamOwnerEmail(userData.teamId) : null;
    await axios({
      method: "post",
      url: getFullHttpUrl("stripe-createCustomer"),
      data: {
        name: userData ? (userData.teamId && teamData ? teamData.name : userData.name) : "guest",
        email: email ? email : userData ? userData.email : "",
      },
    })
      .then((res) => {
        if (res.data && res.data.customerId) {
          if (id) {
            if (isTeam) {
              firestore.collection("teams").doc(id).update({
                stripeCustomerId: res.data.customerId,
              });
            } else {
              firestore.collection("users").doc(id).update({
                stripeCustomerId: res.data.customerId,
              });
            }
          }
          setCustomerId(res.data.customerId);
        } else {
          setCustomerId("");
        }
        setIsCardsLoading(false);
      })
      .catch((e) => {
        showNotification(
          "Error",
          "There was an error. Please, try again or refresh the page.",
          "error"
        );
      });
  };

  
  useEffect(() => {
    if(customerId !== ""){
      return;
    }
    setIsCardsLoading(true);
    if(signedIn && userData){
      if(userData.teamId && teamData){
        setCardsList(teamData.paymentMethods ? teamData.paymentMethods : []);
        if(teamData.stripeCustomerId){
          console.log("team exist---> exiting customer ID")
          setCustomerId(teamData.stripeCustomerId);
          setIsCardsLoading(false);
        }else{
          console.log("team exist---> no customer ID")
          getCustomerId(userData.teamId, true);
        }
      }else{
        setCardsList(userData.paymentMethods ? userData.paymentMethods : []);
        if(userData.stripeCustomerId){
          console.log("user exist---> exiting customer ID")
          setCustomerId(userData.stripeCustomerId);
          setIsCardsLoading(false);
        }else{
          console.log("user exist---> no customer ID")
          getCustomerId(userData.id, false)
        }
      }
    }else{
      setIsCardsLoading(false);
      setCustomerId("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData, teamData]);

  useEffect(() => {
    if (cardsList.length > 0) {
      const defaultCard = cardsList.find((card) => card.default === true);
      if (defaultCard) {
        setSelectedCard(defaultCard.id);
        setEditCard(""); // Ensure "Add New Card" is deselected
        setDefaultCard(defaultCard.id);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cardsList]);

  const handleEditCard = (card) => {
    if (card === "new") {
      setEditCard("new");
      setSelectedCard(""); // Deselect any selected card
      // setCardOwner(""); // Reset fields for new card
    } else {
      setEditCard("");
      setSelectedCard(card.id); // Select the chosen card
      setCardOwner(card.billing_details.name); // Prefill owner name
    }
    setEditCardIconSelected("");
  };

  const closeCardForm = () => {
    setEditCard("");
    setSelectedCard("");
    setCardOwner("");
  };

  const handleDefaultCard = async (card) => {
    setEditCard("");
    setEditCardIconSelected("");

    const newCardsList = cardsList.map((d) =>
      d.id === card.id ? { ...d, default: true } : { ...d, default: false }
    );

    try {
      firestore
        .collection(userData.teamId ? "teams" : "users")
        .doc(userData.teamId ? userData.teamId : userData.id)
        .update({
          paymentMethods: newCardsList,
        })
        .then(() => {
          setDeleteModalCard(null);
          setEditCard("");
          setEditCardIconSelected("");
        });
    } catch (e) {
      // console.log(e);
      showNotification(
        "Error",
        "There was an error. Please, try again or refresh the page.",
        "error"
      );
    }
  };

  const handleDeleteCard = async (card) => {
    setDeleteBtnText("Deleting...");

    const newCardsList = cardsList.filter((d) => d.id !== card.id);
    if (card.default === true) {
      setDefaultCard("");
    }

    try {
      await axios({
        method: "post",
        url: getFullHttpUrl("stripe-detachPaymentMethod"),
        data: {
          paymentMethodId: card.id,
        },
      });

      const docType = userData && userData.teamId ? "teams" : "users";
      const docId = userData && userData.teamId ? userData.teamId : userData.id;

      await firestore
        .collection(docType)
        .doc(docId)
        .update({
          paymentMethods: newCardsList,
        });

      setDeleteModalCard(null);
      setDeleteBtnText("Delete Card");
      setEditCard("");
      setEditCardIconSelected("");

    } catch (e) {
      console.log(e)
      showNotification(
        "Error",
        "There was an error. Please, try again or refresh the page.",
        "error"
      );
      setDeleteBtnText("Delete Card");
    }
  };

  // For Account Billing Save Button
  const handleSaveCard = async (e) => {
    e.preventDefault();

    if (
      cardOwner === "" ||
      cardCVCEmpty === "" ||
      cardNumberEmpty === "" ||
      cardExpiryEmpty === ""
    ) {
      showNotification(
        "Error",
        "Please enter all fields in card form.",
        "error"
      );
      return;
    }

    if (!stripe || !elements) {
      showNotification(
        "Error",
        "There was an error. Please, try again or refresh the page.",
        "error"
      );
      return;
    }
    setSaveEditsBtnText("Saving...");
    try {
      const intentRes = await axios({
        method: "post",
        url: getFullHttpUrl("stripe-setUpPaymentIntent"),
        data: {
          customerId: customerId
        },
      });

      const client_secret = intentRes.data.client_secret;

      const result = await stripe.confirmCardSetup(client_secret, {
        payment_method: {
          card: elements.getElement(CardNumberElement),
          billing_details: {
            name: cardOwner,
          },
        },
      });

      if (result.error) {
        // console.log(result.error)
        showNotification("Error", result.error.message, "error");
        setSaveEditsBtnText("Save");
      } else {

        console.log(result)
        const { payment_method: paymentMethodId } = result.setupIntent;

        // axios({
        //   method: "post",
        //   url: getFullHttpUrl("stripe-retrieveIntent"),
        //   data: {
        //     intent: intentRes.data.id,
        //     refundAmount: true
        //   },
        // })

        if (userData && customerId) {
          await axios({
            method: "post",
            url: getFullHttpUrl("stripe-attachPaymentMethodToCustomer"),
            data: {
              customerId: customerId,
              paymentMethodId: paymentMethodId,
            },
          }).then((res) => {
            const defaultCard = cardsList.length === 0 ? true : false;
            const methodDetails = res.data.paymentMethod;
            const docType = userData.teamId && teamData ? "teams" : "users";
            const docId = userData.teamId && teamData ? userData.teamId : userData.id;
            firestore
              .collection(docType)
              .doc(docId)
              .update({
                paymentMethods: [
                  ...cardsList,
                  {
                    default: defaultCard,
                    card: methodDetails.card,
                    id: methodDetails.id,
                    billing_details: methodDetails.billing_details,
                    customer: methodDetails.customer
                  },
                ],
              })
              .then(() => {
                setSelectedCard("");
                setEditCard("");
                setEditCardIconSelected("");
              });
          });
        }
      }
    } catch (e) {
      console.log(e)
      showNotification(
        "Error",
        "There was an error. Please, try again or refresh the page.",
        "error"
      );
    } finally {
      setSaveEditsBtnText("Save");
    }
  };

  return (
    <>
      {deleteModalCard && (
        <PopUpModal
          title={"Delete Card"}
          backBtnText="Back to Payments"
          subText="Are you sure you want to delete this card?"
          text={
            deleteModalCard.card.brand.toUpperCase() +
            " Ending " +
            deleteModalCard.card.last4
          }
          btnText={deleteBtnText}
          iconBgColor="#FFF6EA"
          deleteBtn={true}
          showClose
          onClose={() => setDeleteModalCard(null)}
          onClick={() => {
            handleDeleteCard(deleteModalCard);
          }}
          onBackClick={() => setDeleteModalCard(null)}
          disableBtn={deleteBtnText === "Deleting..."}
        >
          <DELCARD />
        </PopUpModal>
      )}


      {isCardsLoading && (
        <NoData loading loadingText={"Cards"} showBtn={false} />
      )}

      {signedIn &&
        userData &&
        !isCardsLoading &&
        cardsList &&
        cardsList.map((card, i) => (
          <div
            key={card.id}
            className="hardCopyAddressContainer"
            onClick={() => {
              type !== "save" && setSelectedCard(card.id);
              // handleEditCard(card);
            }}
            style={{
              borderColor: selectedCard === card.id ? "#12ABBF" : "#E6E7E9",
            }}
          >
            <div className="cardRow">
              <div className="CardIconWrapper">
                {card.card.brand === "visa" && (
                  <img src={VISA} className="cardImg" alt="" />
                )}
                {card.card.brand === "diners" && (
                  <img src={DINER} className="cardImg" alt="" />
                )}
                {card.card.brand === "discover" && (
                  <img src={DISCOVER} className="cardImg" alt="" />
                )}
                {card.card.brand === "amex" && (
                  <img src={AMEX} className="cardImg" alt="" />
                )}
                {card.card.brand === "mastercard" && (
                  <img src={MASTER} className="cardImg" alt="" />
                )}
                {card.card.brand === "jcb" && (
                  <img src={JCB} className="cardImg" alt="" />
                )}
                {card.card.brand === "maestro" && (
                  <img src={MAESTRO} className="cardImg" alt="" />
                )}
                <img src={CARDICON} className="emptyCardImg" alt="" />
              </div>
              <div className="quoteOptionalTitleRow">
                <div className="hardCopyAddressDetails">
                  <h6
                    className="hardCopyAddressTitle"
                    style={{ fontWeight: 600 }}
                  >
                    {card.card.brand.toUpperCase()} Ending {card.card.last4}{" "}
                    <span>{card.default && "(primary)"}</span>
                  </h6>
                  <p className="hardCopyAddressText">
                    {card.billing_details.name} | Expire {card.card.exp_month}/
                    {card.card.exp_year}
                  </p>
                </div>

              {userData && userData.teamId && teamData ? card.default && teamData.billingTerm && teamData.billingTerm !== "case-by-case" ? null :
                    card.default && pendingInvoices ? null :
                (userData.teamRole === AccountType.OWNER ||
                  userData.teamRole === "admin") && <div
                  className="hardCopyAddressIconWrap"
                  onClick={(e) => {
                    e.stopPropagation();
                    setEditCardIconSelected((prev) => (prev === i ? "" : i));
                  }}
                  tabIndex={0}
                  onBlur={() => setEditCardIconSelected("")}
                >
                  {editCardIconSelected === i ? (
                    <MORESELECTED className="hardCopyAddressIcon" />
                  ) : (
                    <MORE className="hardCopyAddressIcon" />
                  )}

                  {editCardIconSelected === i &&  (
                    <div className="hardCopyAddressEditWrap">
                      {!card.default && (
                        <div
                          className="hardCopyAddressEdit"
                          onClick={() => handleDefaultCard(card)}
                        >
                          Set as Primary
                        </div>
                      )}
                     {<div
                        className="hardCopyAddressEdit"
                        onClick={() => {
                          setDeleteModalCard(card);
                          setEditCard("");
                          setEditCardIconSelected("");
                        }}
                      >
                        Delete Payment Method
                      </div>}
                    </div>
                  )}
                </div> :
                 userData && <div
                 className="hardCopyAddressIconWrap"
                 onClick={(e) => {
                   e.stopPropagation();
                   setEditCardIconSelected((prev) => (prev === i ? "" : i));
                 }}
                 tabIndex={0}
                 onBlur={() => setEditCardIconSelected("")}
               >
                 {editCardIconSelected === i ? (
                   <MORESELECTED className="hardCopyAddressIcon" />
                 ) : (
                   <MORE className="hardCopyAddressIcon" />
                 )}

                 {editCardIconSelected === i &&  (
                   <div className="hardCopyAddressEditWrap">
                     {!card.default && (
                       <div
                         className="hardCopyAddressEdit"
                         onClick={() => handleDefaultCard(card)}
                       >
                         Set as Primary
                       </div>
                     )}
                    {<div
                       className="hardCopyAddressEdit"
                       onClick={() => {
                         setDeleteModalCard(card);
                         setEditCard("");
                         setEditCardIconSelected("");
                       }}
                     >
                       Delete Payment Method
                     </div>}
                   </div>
                 )}
               </div>
                }
              </div>
            </div>

            {/* Show edit form if this card is selected for editing */}
            {editCard && editCard.id === card.id && (
              <div className="editInputsContainer">
                <form className="cardForum" onSubmit={() => { }}>
                  <div className="cardElementWrap">
                    <FormCardInput
                      placeholder="Card Number"
                      type="number"
                      onReady={() => setCardNumberLoaded(true)}
                      empty={cardNumberEmpty}
                      setEmpty={setCardNumberEmpty}
                      value={"**** **** **** " + card.card.last4} // Show last 4 digits only
                      readOnly
                    />
                    <div className="cardElementWrap">
                      <FormCardInput
                        placeholder="MM/YY"
                        type="expiry"
                        onReady={() => setCardExpiryLoaded(true)}
                        empty={cardExpiryEmpty}
                        setEmpty={setCardExpiryEmpty}
                        value={card.card.exp_month + "/" + card.card.exp_year}
                        readOnly
                      />
                      <FormCardInput
                        placeholder="CVC"
                        type="cvc"
                        onReady={() => setCardCvcLoaded(true)}
                        empty={cardCVCEmpty}
                        setEmpty={setCardCVCEmpty}
                      />
                    </div>
                  </div>
                  {cardNumberLoaded && cardCvcLoaded && cardExpiryLoaded && (
                    <FormTextInput
                      value={cardOwner}
                      onChange={setCardOwner}
                      placeholder="Name on Card"
                    />
                  )}
                </form>

                <div className="editInputBtnContainer">
                  <NewButton
                    onClick={(e) => handleSaveCard(e)}
                    disabled={saveEditsBtnText === "Saving..."}
                    text={saveEditsBtnText}
                    width="150px"
                    smallPadding={true}
                  />
                  <NewButton
                    onClick={() => {
                      setEditCard("");
                      setEditCardIconSelected("");
                    }}
                    text="Cancel"
                    icon={false}
                    whiteBtn
                    back={true}
                    width="150px"
                    smallPadding={true}
                  />
                </div>
              </div>
            )}
          </div>
        ))}

      {!isCardsLoading && showNewCard && (
        <div
          className="hardCopyAddressContainer"
          onClick={() => {
            if (signedIn && userData) {
              handleEditCard("new");
            }
          }}
          style={{ borderColor: editCard === "new" ? "#12ABBF" : "#E6E7E9" }}
        >
          <div className="cardRow">
            <div className="CardIconWrapper">
              <img src={CARDICON} className="emptyCardImg" alt="" />
            </div>
            <div className="quoteOptionalTitleRow">
              <div className="hardCopyAddressDetails">
                <h6
                  className="hardCopyAddressTitle"
                  style={{ marginTop: "2px", fontWeight: 600 }}
                >
                  Add New Card
                </h6>
              </div>
            </div>
          </div>

          {(!signedIn || cardsList.length === 0 || editCard === "new") && (
            <div className="editInputsContainer">
              <form className="cardForum" onSubmit={() => { }}>
                <div className="cardElementWrap">
                  <FormCardInput
                    placeholder={"Card Number"}
                    type="number"
                    onReady={() => setCardNumberLoaded(true)}
                    empty={cardNumberEmpty}
                    setEmpty={setCardNumberEmpty}
                  />
                  <div className="cardElementWrap">
                    <FormCardInput
                      placeholder={"MM/YY"}
                      type="expiry"
                      onReady={() => setCardExpiryLoaded(true)}
                      empty={cardExpiryEmpty}
                      setEmpty={setCardExpiryEmpty}
                    />
                    <FormCardInput
                      placeholder={"CVC"}
                      type="cvc"
                      onReady={() => setCardCvcLoaded(true)}
                      empty={cardCVCEmpty}
                      setEmpty={setCardCVCEmpty}
                    />
                  </div>
                </div>
                {cardNumberLoaded && cardCvcLoaded && cardExpiryLoaded && (
                  <FormTextInput
                    value={cardOwner}
                    onChange={setCardOwner}
                    placeholder="Name on Card"
                  />
                )}
                {showChargeWarning && <div className="expeditedPlusErrorWrap">
                  <p className="expeditedPlusErrorText">
                    A temporary $1 charge will be applied to verify your card. This amount will be refunded shortly.
                  </p>
                </div>}
              </form>
              {signedIn &&
                type !== "save" &&
                cardNumberLoaded &&
                cardCvcLoaded &&
                cardExpiryLoaded && (
                  <div
                    className="hardCopyCheckboxLine"
                    onClick={() => {
                      setSaveCard((prev) => !prev);
                    }}
                  >
                    <div className={`${saveCard ? "hardCopyChecked" : ""} hardCopyCheckbox`}>
                      <Check
                        className="hardCopyCheck"
                        style={{ opacity: saveCard ? 1 : 0 }}
                      />
                    </div>
                    <p className="hardCopyCheckboxText">Save card</p>
                  </div>
                )}

              {type === "save" && (
                <div className="editInputBtnContainer">
                  <NewButton
                    onClick={(e) => handleSaveCard(e)}
                    disabled={
                      saveEditsBtnText === "Saving..." ||
                      cardNumberEmpty === "" ||
                      cardExpiryEmpty === "" ||
                      cardCVCEmpty === "" ||
                      cardOwner === ""
                    }
                    text={saveEditsBtnText}
                    width="150px"
                    smallPadding={true}
                  />
                  <NewButton
                    onClick={(e) => {
                      e.stopPropagation();
                      closeCardForm();
                    }}
                    text={"Cancel"}
                    icon={false}
                    whiteBtn
                    back={true}
                    width="150px"
                    smallPadding={true}
                  />
                </div>
              )}
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default Billing;
